import { type QueryTags } from 'lib/rtkQuery/constants';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type QueryTagValue = (typeof QueryTags)[keyof typeof QueryTags];
// eslint-disable-next-line @typescript-eslint/naming-convention
export type QueryTagArray = QueryTagValue[];

export const invalidatesTags = (tags: QueryTagArray) => (result: unknown) => {
  return result !== undefined ? tags : [];
};
